import { Breakpoints } from '@estee/elc-base-theme';

const SCROLL_BEHAVIOR = 'smooth';
const SCROLL_BLOCK = 'start';
const SCROLL_QUERY = `(min-width: ${Breakpoints.desktop}px)`;

export const scrollTo = (desktopElement: HTMLElement | null, mobileElement: HTMLElement | null) => {
    const isDesktop = window.matchMedia(SCROLL_QUERY).matches;
    const element = isDesktop ? desktopElement : mobileElement;

    element?.scrollIntoView({
        behavior: SCROLL_BEHAVIOR,
        block: SCROLL_BLOCK
    });
};
